import * as yup from "yup"
import type { Theme } from "../../types"

export function initialValuesTheme(theme?: Theme | undefined) {
  if (theme) {
    return theme
  }
  return {
    name: "",
    description: "",
    image: undefined,
    order: 0,
    main_color: "",
  }
}

export function validationSchemaTheme() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
    image: yup.mixed().required("Campo obbligatorio"),
    main_color: yup.string().required("Campo obbligatorio"),
  })
}
